import { coverageApi } from './coverage';
import { policiesApi } from './policy/policy.api';
import { combineReducers } from '@reduxjs/toolkit';
import { authApi } from '@store/auth';
import authSlice from '@store/auth/auth.slice';
import coverageSlice from '@store/coverage/coverage.slice';
import { outagesApi } from '@store/outages/outages.api';
import policySlice from '@store/policy/policy.slice';
import { typeOfBusinessCategoriesApi } from '@store/typeOfBusinessCategories/typeOfBusinessCategories.api';
import { usTerritoriesApi } from '@store/usTerritories/usTerritories.api';
import { userApi } from '@store/user';

export const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [outagesApi.reducerPath]: outagesApi.reducer,
  [coverageApi.reducerPath]: coverageApi.reducer,
  [usTerritoriesApi.reducerPath]: usTerritoriesApi.reducer,
  [typeOfBusinessCategoriesApi.reducerPath]: typeOfBusinessCategoriesApi.reducer,
  [policiesApi.reducerPath]: policiesApi.reducer,
  authSlice,
  coverageSlice,
  policySlice,
});